import { colors } from '@core/assistant/colors';

export const useStyles = () => {
  return {
    root: {
      position: 'relative',
    },
    controls: {
      position: 'absolute',
      right: '12px',
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'flex',
      gap: 2,
    },
    box: {
      width: '100%',

      '& > :after': {
        display: 'none',
      },
      '& > :before': {
        display: 'none',
      },
    },
    button: {
      padding: 0,
    },
    icon: {
      width: 16,
      height: 16,
      display: 'block',
      color: colors.grey_200,
    },
    input: {
      color: colors.white,
      background: colors.grey_1,
      borderRadius: '8px',
      padding: '12px 104px 12px 12px',
      fontSize: '14px',
      height: '14px',
      lineHeight: 1,
    },
    micOn: {
      width: 16,
      height: 16,
      display: 'block',
      color: colors.red,
    },
  };
};
